import {useEffect} from 'react';

export default function useHtmlClass(htmlClass) {
    useEffect(() => {
        document.documentElement.classList.add(htmlClass);
        return () => document.documentElement.classList.remove(htmlClass);
    });

    return null;
}